import React from "react";
import styled from "styled-components";
import { animated, useSpring } from "react-spring";
import { useInView } from "react-intersection-observer";
import Title from "./Title";
import { device } from "../styles/media-query";
import { useMyMediaQuery } from "../hooks/useMediaQuery";

const Container = styled.section`
  display: flex;
  z-index: 10;
  flex-direction: column;
  min-height: 80vh;
  margin: 0 auto;
  ${device.tablet} {
    padding: 12rem 6rem;
  }
  ${device.mobile} {
    padding: 8rem 2rem;
  }
  ${device.desktop} {
    max-width: 1080px;
    padding: 20rem 4rem;
    margin: 0 auto;
  }
`;

const TextContainer = styled.div`
  flex-direction: column;

  ${device.desktop} {
    display: flex;
    align-content: flex-start;
    flex-direction: row;
    justify-content: space-between;
  }
`;

const Text = styled.div`
  font-size: 24px;
  ${device.tablet} {
    font-size: 20px;
  }
  ${device.mobile} {
    font-size: 16px;
    line-height: 20px;
  }
  line-height: 30px;
  color: white;
`;

const Description = styled.div`
  flex: 1;
  margin-top: 60px;
  ${device.desktop} {
    margin-top: 0;
  }
`;

function About() {
  const { ref: titleRef, inView } = useInView({ triggerOnce: true });

  const { isDesktop } = useMyMediaQuery();

  const titleStyle = useSpring({
    delay: 200,
    to: {
      transform: inView ? "translateY(0)" : "translateY(30px)",
      opacity: inView ? 1 : 0,
    },
    config: { duration: 500 },
  });

  return (
    <Container id={"about"}>
      <animated.div style={titleStyle}>
        <TextContainer ref={titleRef}>
          <div
            ref={titleRef}
            style={{ marginRight: isDesktop ? "15rem" : undefined }}
          >
            <Title
              text={
                <>
                  About <br /> the HYPER
                </>
              }
            />
          </div>
          <Description>
            <Text>
              <div style={{ marginBottom: 30 }}>
                The Hyper is a blockchain service studio <br />
                founded by a team of serial entrepreneurs and developers.
              </div>

              <div>
                We incubate and accelerate the teams that make a new wave of
                web3 technology.
              </div>
            </Text>
          </Description>
        </TextContainer>
      </animated.div>
    </Container>
  );
}

export default About;
